import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create(() => ({
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 24,
    paddingHorizontal: theme.spacing[5],
    paddingTop: theme.spacing[2],
  },
  header: {
    alignItems: 'center',
    gap: theme.spacing[5],
  },
  footer: {
    paddingHorizontal: theme.spacing[5],
    paddingBottom: theme.spacing[8],
  },
}));
